
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Services = lazy(() => import('../pages/services/page'));
const ServiceDetail = lazy(() => import('../pages/service-detail/page'));
const Testimonials = lazy(() => import('../pages/testimonials/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const Kvkk = lazy(() => import('../pages/kvkk/page'));
const CookiePolicy = lazy(() => import('../pages/cookie-policy/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/hakkimizda',
    element: <About />,
  },
  {
    path: '/hizmetler',
    element: <Services />,
  },
  {
    path: '/hizmetler/:slug',
    element: <ServiceDetail />,
  },
  {
    path: '/yorumlar',
    element: <Testimonials />,
  },
  {
    path: '/iletisim',
    element: <Contact />,
  },
  {
    path: '/kvkk',
    element: <Kvkk />,
  },
  {
    path: '/cerez-politikasi',
    element: <CookiePolicy />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
